import { customInstance } from '@/features/auth/axios-config'

import {
  COMPLETED_SORT_BY,
  COMPLETED_STATUSES,
  IN_PROGRESS_SORT_BY,
  IN_PROGRESS_STATUSES,
  MY_WORK_API_ENDPOINT,
  MY_WORK_DEFAULT_LIMIT,
  MY_WORK_DEFAULT_OFFSET,
} from './constants'
import {
  MyWorkCompletedRequest,
  MyWorkInProgressRequest,
  MyWorkResponse,
} from './types'

export const myWorkApi = {
  getInProgress: async (
    limit: number = MY_WORK_DEFAULT_LIMIT,
    offset: number = MY_WORK_DEFAULT_OFFSET,
    search?: string
  ): Promise<MyWorkResponse> => {
    const requestBody: MyWorkInProgressRequest = {
      filter_by: {
        status: IN_PROGRESS_STATUSES,
      },
      sort_by: IN_PROGRESS_SORT_BY,
      limit,
      offset,
      ...(search && { q: search }),
    }

    return customInstance<MyWorkResponse>({
      method: 'post',
      url: MY_WORK_API_ENDPOINT,
      data: requestBody,
    })
  },

  getCompleted: async (
    limit: number = MY_WORK_DEFAULT_LIMIT,
    offset: number = MY_WORK_DEFAULT_OFFSET,
    search?: string
  ): Promise<MyWorkResponse> => {
    const requestBody: MyWorkCompletedRequest = {
      filter_by: {
        status: COMPLETED_STATUSES,
      },
      sort_by: COMPLETED_SORT_BY,
      limit,
      offset,
      ...(search && { q: search }),
    }

    return customInstance<MyWorkResponse>({
      method: 'post',
      url: MY_WORK_API_ENDPOINT,
      data: requestBody,
    })
  },
}
